module.exports = __webpack_public_path__ + "static/media/e1.b6af3413.jpg";